<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-settings-cycles-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('params.back_cycles')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('params.new_cycle') : $t('params.edit_cycle')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <div class="font-weight-bold mb-2 mt-3">{{$t('params.label')}} *</div>
                <v-text-field v-model="cycle.label" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
            </div>
            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <router-link :to="{name: 'admin-settings-cycles-index'}" class="grey--text">{{$t('_.cancel')}}</router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                cycle: {
                    id: null,
                    label: null
                },
                formValid: false,
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('cycles', this.$route.params.id).then(res => {
                    this.cycle = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('cycles', this.cycle).then(() => {
                        this.$router.push({name: 'admin-settings-cycles-index'});
                        this.$snotify.success(this.$t('params.cycle_created'));
                    })
                } else {
                    Params.update('cycles', this.cycle.id, this.cycle).then(() => {
                        this.$router.push({name: 'admin-settings-cycles-index'});
                        this.$snotify.success(this.$t('params.cycle_edited'));
                    })
                }
            },
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            },
        }
    }
</script>